//certifications

//   http://dev-hydronew.azurewebsites.net/api/Help/Api/GET-api-Patron-GetAllActivity_LocationId

//FG - FOOF - Jan 6 2019 - the function below used to be called getAllLogReadings but when I
//   modified the code to do better duplicate name checking I changed it to getAllCustomLogReadings
//   because it gets ONLY the custom readings.
export const GetAllCustomLogReadings = (locationid) => {
  return $.get('LogTemplate/GetAllLogReadings?IsCustom=true&IsActive=true')
}
//FG - FOOF - Jan 6 2019 - added the function below when I added code for better duplicate name
//  checks.  It gets only the delivered chem readings (does not include custom readings)
export const GetAllDeliveredLogReadings = (locationid) => {
  return $.get('LogTemplate/GetAllLogReadings?IsCustom=false&IsActive=null')
}
export const AddLogReadings = (model) => {
  return $.ajax({
    url: 'LogTemplate/UpdateCustomLogReadingsList',
    data: JSON.stringify(model),
    contentType: 'application/json',
    cache: false,
    type: 'POST'
  })
}

export const DeleteLogReadings = (Id) => {
  return $.post('LogTemplate/DeleteLogReadings?Id=' + Id)
}








// WEBPACK FOOTER //
// ./src/components/CustomReadings/custom_readings.service.js